<template>
<!-- 主管部门 -->
  <div></div>
</template>

<script>
export default {
  data () {
    return {
      timer: '',
    }
  },
  mounted () {
    this.backPage()
  },
  methods: {
    backPage () {
      this.$message.warning('内容暂未更新')
      this.timer = setTimeout(() => {
        this.$router.go(-1)
      }, 1000)
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/detail/components/Department.vue